import { openDB } from 'idb';
import { EVENT_ID } from '../core/config.js';

let dbOpenPromise = null;

export let db = null;               // use this module-level handle
let _intervals = [];                // FIX: was null → [] so .push() works

export function isTransientIdbError(err) {
    return !!err && (
        err.name === 'InvalidStateError' ||
        /closing/i.test(err.message || '')
    );
}

export async function ensureDb() {
    // If we have an existing DB, check it's usable
    if (db) {
        try {
            db.transaction('badges');      // noop to test state
            return db;
        } catch (e) {
            // closed/closing → drop and reopen
            try { db.close?.(); } catch { }
            db = null;
        }
    }

    if (!dbOpenPromise) {
        dbOpenPromise = openDB(`checkin-${EVENT_ID}`, 2, {
            upgrade(idb) {
                if (!idb.objectStoreNames.contains('badges')) {
                    idb.createObjectStore('badges', { keyPath: 'uuid' });
                }
            },
            blocked() {
                console.warn('[checkin] IDB open blocked by another tab/version.');
            },
            blocking() {
                try { db?.close?.(); } catch { }
                db = null;
            },
            terminated() {
                console.warn('[checkin] IDB connection terminated.');
                db = null;
            }
        })
            .then(idb => {
                db = idb;
                dbOpenPromise = null;
                return idb;
            })
            .catch(err => {
                dbOpenPromise = null;
                throw err;
            });
    }

    return dbOpenPromise;
}

export async function withDb(fn) {
    try {
        const idb = await ensureDb();
        return await fn(idb);
    } catch (err) {
        if (isTransientIdbError(err)) {
            console.warn('[checkin] transient IDB error, will ignore this tick', err);
            return undefined;
        }
        throw err;
    }
}

export function clearAllIntervals() {
    if (!_intervals || _intervals.length === 0) return;  // guard
    for (const id of _intervals) clearInterval(id);
    _intervals.length = 0;
}

export function safeInterval(fn, ms) {
    if (!_intervals) _intervals = [];                    // extra guard
    const id = setInterval(async () => {
        try {
            await fn();
        } catch (err) {
            if (!isTransientIdbError(err)) console.error(err);
        }
    }, ms);
    _intervals.push(id);
    return id;
}
